<script>
export default {
  components: {},
  props: {
    type: {
      type: String,
      required: true,
      default: '',
    },
    target: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    duplicateTitle() {
      return `Duplicate ${this.target}`;
    },
  },
  mounted() {},
  methods: {
    archiveClient() {
      this.$emit('archive-client');
    },
    archiveProgram() {
      this.$emit('archive-program');
    },
    handleDuplicate() {
      this.$emit('handle-duplicate');
    },
    assignToClient() {
      this.$emit('assign-client');
    },
    deleteFitnessType() {
      this.$emit('delete-FitnessType');
    },
  },
};
</script>

<template>
  <ul>
    <li v-if="type === 'delete-fitnessType'" @click.stop="deleteFitnessType">
      <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.719 3.906h-3.405L12.92 1.61c-.328-.533-1.066-.984-1.682-.984H7.096c-.616 0-1.354.451-1.682.984L4.02 3.906H.656A.675.675 0 000 4.562v.657c0 .369.287.656.656.656h.656l.862 13.904c.04 1.026.943 1.846 1.969 1.846H14.19c1.026 0 1.928-.82 1.97-1.846l.901-13.904h.657a.675.675 0 00.656-.656v-.657c0-.328-.328-.656-.656-.656zM7.096 2.594h4.142l.78 1.312H6.316l.78-1.312zm7.095 17.062H4.143L3.28 5.875h11.772l-.862 13.781z" fill="#000"/></svg>
    </li>
    <li v-if="type === 'archive'" @click.stop="archiveClient">
      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon invert-color'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
      <span>Archive Client</span>
    </li>
    <li v-if="type === 'duplicate'" @click.stop="handleDuplicate">
      <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
      <span>{{ duplicateTitle }}</span>
    </li>
    <!-- these 👇 can potentially be refactored when/if all views change - now it is specicific to pogram list -->
    <li v-if="type === 'duplicate-program'" @click.stop="handleDuplicate">
      <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.76 3.332L15.668 1.24c-.328-.328-.943-.615-1.395-.615H7.22a1.97 1.97 0 00-1.97 1.969v1.969H1.969A1.97 1.97 0 000 6.53v13.125c0 1.108.861 1.969 1.969 1.969h9.187a1.97 1.97 0 001.969-1.969v-1.968h3.281a1.97 1.97 0 001.969-1.97V4.728c0-.452-.287-1.067-.615-1.395zm-6.85 16.324H2.215c-.164 0-.246-.082-.246-.246V6.777c0-.123.082-.246.246-.246H5.25v9.188c0 1.107.861 1.969 1.969 1.969h3.937v1.722c0 .164-.123.246-.246.246zm5.25-3.937H7.465c-.164 0-.246-.082-.246-.246V2.84c0-.123.082-.246.246-.246h4.348v3.61c0 .573.41.984.984.984h3.61v8.285c0 .164-.124.246-.247.246zm.246-10.5h-2.625V2.594h.37c.081 0 .122.04.164.082l2.01 2.01c.04.04.081.082.081.164v.369z" fill="#000"/></svg>
    </li>
    <li v-if="type === 'archive-program'" @click.stop="archiveProgram">
      <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.719 3.906h-3.405L12.92 1.61c-.328-.533-1.066-.984-1.682-.984H7.096c-.616 0-1.354.451-1.682.984L4.02 3.906H.656A.675.675 0 000 4.562v.657c0 .369.287.656.656.656h.656l.862 13.904c.04 1.026.943 1.846 1.969 1.846H14.19c1.026 0 1.928-.82 1.97-1.846l.901-13.904h.657a.675.675 0 00.656-.656v-.657c0-.328-.328-.656-.656-.656zM7.096 2.594h4.142l.78 1.312H6.316l.78-1.312zm7.095 17.062H4.143L3.28 5.875h11.772l-.862 13.781z" fill="#000"/></svg>
    </li>
    <li v-if="type === 'assign-client'" @click.stop="assignToClient">
      <svg width="27" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.188 12.438a5.908 5.908 0 005.906-5.907c0-3.24-2.666-5.906-5.906-5.906A5.908 5.908 0 003.28 6.531a5.882 5.882 0 005.906 5.907zm0-9.844c2.132 0 3.937 1.804 3.937 3.937 0 2.174-1.805 3.938-3.938 3.938A3.939 3.939 0 015.25 6.53c0-2.133 1.764-3.937 3.938-3.937zm3.65 10.5c-1.19 0-1.723.656-3.65.656-1.97 0-2.502-.656-3.692-.656C2.461 13.094 0 15.596 0 18.63v1.025c0 1.108.861 1.969 1.969 1.969h14.437a1.97 1.97 0 001.969-1.969V18.63c0-3.035-2.502-5.537-5.537-5.537zm3.568 6.562H1.97v-1.025c0-1.969 1.558-3.569 3.527-3.569.615 0 1.559.657 3.691.657 2.092 0 3.036-.656 3.65-.656a3.57 3.57 0 013.57 3.568v1.025zm9.188-10.172H22.64V6.531c0-.328-.328-.656-.657-.656h-.656a.675.675 0 00-.656.656v2.953h-2.953a.675.675 0 00-.657.657v.656c0 .369.288.656.657.656h2.953v2.953c0 .37.287.656.656.656h.656a.675.675 0 00.657-.656v-2.953h2.953a.674.674 0 00.656-.656v-.656c0-.329-.328-.657-.656-.657z" fill="#000"/></svg>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable selector-max-type
ul {
  @include calc-font-size(0.7);

  padding-bottom: 1rem;
  width: 100%;
}

.divider-horizontal {
  align-self: center;
  border-top: 1px solid white;
  height: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  opacity: 0.2;
  width: 80%;
}
.icon {
  height: 1.5rem;
  margin-right: 0.8rem;
  width: 1.8rem;
  path {
    fill: black;
  }
}

span {
  text-transform: capitalize;
}

li {
  border-radius: $base-border-radius-md;
  cursor: pointer;
  padding: 1rem;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover {
    background-color: $color-heading-text;

    .icon {
      path {
        fill: $color-tooltip-calendar-bg;
      }
    }
  }

  // &:first-child {
  //   padding-top: 1rem;

  //   &:hover {
  //     background-color: $color-heading-text;
  //     border-top-left-radius: $base-border-radius-md;
  //     border-top-right-radius: $base-border-radius-md;
  //   }
  // }
  span {
    @include calc-font-size(0.7);

    font-weight: 800;
    letter-spacing: 0.116667px;
  }
}
</style>
